var map = {
	"./ccna.png": 2940,
	"./coursera-01.png": 7673,
	"./datacamp-01.png": 8360,
	"./iitg-01.png": 82,
	"./iitg.png": 9652,
	"./ineuron-01.png": 8881,
	"./kaggle.png": 9082,
	"./problem-01.png": 2874,
	"./python-01.png": 7263,
	"./simplilearn-01.png": 289,
	"./tabana-01.png": 186,
	"./tabcon-01.png": 8724,
	"./udemy-01.png": 5383
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9229;